import styled from "@emotion/styled";
export const StyledMobileContentComponent = styled.div`
  height: 100%;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  padding-bottom: 54px;
`;
